import React, {useMemo} from 'react';
import CustomReactSelect from "v4/components/form/Field/components/CustomReactSelect/CustomReactSelect";
import AdminListEditor from "v4/features/admin/adminForms/components/AdminListEditor/AdminListEditor";
import useAdminListEditor from "v4/features/admin/adminForms/components/AdminListEditor/hooks/useAdminListEditor";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

const TASK_TYPE_STATUS_FIELDS = [
    'isTimestamped',
    'isMailing',
    'isSynchroOutlook',
    'isReminder',
    'isUnSelectable',
];

function getTaskTypeStatus(item) {
    return TASK_TYPE_STATUS_FIELDS.filter(field => item[field]);
}

export default function TaskType({rawValuesFromAdmin}) {
    const {t} = usePolTranslation();

    const taskTypeStatusOptions = useMemo(() => ([
        {value: "isTimestamped", label: t('is_time_stamped')},
        {value: "isMailing", label: t('is_mailing')},
        {value: "isSynchroOutlook", label: t('is_synchro_outlook')},
        {value: "isReminder", label: t('is_reminder')},
        {value: "isUnSelectable", label: t('is_un_selectable')},
    ]), [t]);

    const {
        fields,
        handleSubmit,
        register,
        onDelete,
        onAdd,
        onExtraChange,
        fieldName,
    } = useAdminListEditor({
        rawValuesFromAdmin,
        entityCode: 'TaskType',
        mapInputs: (item) => ({
            itemId: item.id,
            value: item.name,
            extra: {
                taskTypeStatus: getTaskTypeStatus(item),
            },
        }),
        mapSubmitItem: (item, index, customerId) => ({
            id: item.itemId,
            name: item.value,
            order: index + 1,
            "@type": "TaskType",
            isTimestamped: item.extra.taskTypeStatus.includes('isTimestamped'),
            isMailing: item.extra.taskTypeStatus.includes('isMailing'),
            isSynchroOutlook: item.extra.taskTypeStatus.includes('isSynchroOutlook'),
            isReminder: item.extra.taskTypeStatus.includes('isReminder'),
            isUnSelectable: item.extra.taskTypeStatus.includes('isUnSelectable'),
            customerId: customerId,
        }),
        createEmptyItem: () => ({value: '', extra: {taskTypeStatus: []}}),
    });

    return (
        <AdminListEditor
            title="TaskType"
            fields={fields}
            handleSubmit={handleSubmit}
            register={register}
            onDelete={onDelete}
            onAdd={onAdd}
            fieldName={fieldName}
            renderItemExtras={(input, index) => (
                <div className="admin-list__extras">
                    <CustomReactSelect name={`${fieldName}.${index}.extra.taskTypeStatus`}
                                       value={input.extra.taskTypeStatus ?? []}
                                       options={taskTypeStatusOptions}
                                       isMulti
                                       onChange={onExtraChange(index, 'taskTypeStatus')}/>
                </div>
            )}
        />
    );
}
